// extracted by mini-css-extract-plugin
export default {"cls1":"f5o0rLLV479Xh4DXCAG2","cls2":"yScT2F3PctVkeGmGhzUo f5o0rLLV479Xh4DXCAG2"};